import React, { useState } from "react";
import "./footer.scss";
import nietLogo from "../../domains/contentLibrary/assets/images/NIET-logos/NIET_Logo_white.png";
import {
  useAppUserManager,
  useClusterManager,
  useDistrictManager,
  useOrgManager,
  useSchoolManager,
} from "../../hooks/useManagers";
import { useFeedbackManager } from "../../hooks/useManagers";
import { GetSiteVersion } from "../../utilities/version";
//import { useNavigate } from "react-router-dom";
import { useNavigate } from "../Navigate";
import CloseIcon from "./CloseIcon";
import InfoIcon from "./InfoIcon";

const Footer = (props) => {
  var feedbackMgr = useFeedbackManager();
  const authMgr = useAppUserManager();
  const permissions = authMgr?.GetGlobalState()?.permissions ?? [];
  const [showVirtualLibrarian, setShowVirtualLibrarian] = useState(false);
  const [virtualLibrarianQuestion, setVirtualLibrarianQuestion] = useState("");
  const navigate = useNavigate();

  const handleSubmitVirtualLibrarianQuery = () => {
    if (authMgr?.AccessCheck([permissions?.VirtualLibrarianUser])) {
      sessionStorage.setItem(
        "virtualLibrarianVideoQuestion",
        virtualLibrarianQuestion
      );
      window.dispatchEvent(
        new Event("virtualLibrarianQuestionSubmittedUpdated")
      );
      sessionStorage.setItem("virtualLibrarianLandingInvisible", true);
      window.dispatchEvent(new Event("virtualLibrarianLandingInvisible"));
      setVirtualLibrarianQuestion("");
      setShowVirtualLibrarian(false);

      navigate("/EchoAI");
    } else {
      navigate("/login");
    }
  };

  const toggleVirtualLibrarian = () => {
    setShowVirtualLibrarian(!showVirtualLibrarian);
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmitVirtualLibrarianQuery();
    }
  };

  return (
    <div className="footer">
      <div
        className={`footer-virtual-librarian ${
          showVirtualLibrarian ? "show" : ""
        }`}
      >
        <h4>How can we help?</h4>
        <div className="footer-virtual-librarian-input">
          <input
            type="text"
            placeholder="Ask the Enhanced Search anything!"
            value={virtualLibrarianQuestion}
            onChange={(e) => setVirtualLibrarianQuestion(e.target.value)}
            onKeyDown={handleOnKeyDown}
            maxLength={10000}
          />
          <button
            disabled={virtualLibrarianQuestion.length === 0}
            onClick={handleSubmitVirtualLibrarianQuery}
          >
            SUBMIT
          </button>
        </div>
        <button
          className="footer-virtual-librarian-close"
          onClick={toggleVirtualLibrarian}
        >
          <CloseIcon className="footer-virtual-close-button" />
        </button>
      </div>
      <div className="publicFooter">
        <div className="footer-info-container">
          <img alt="NIET Logo" src={nietLogo} />
          {authMgr?.AccessCheck([permissions?.VirtualLibrarianUser]) && (
            <button
              className="footer-virtual-librarian-open"
              onClick={toggleVirtualLibrarian}
            >
              <p>ENHANCED SEARCH</p>
              <InfoIcon className="footer-info-icon" />
            </button>
          )}
        </div>
        <div className="footer-info-copyright">
          <div>
            {GetSiteVersion()}&nbsp;&nbsp;&nbsp;&nbsp;Copyright{" "}
            {new Date().getFullYear()} by NIET
          </div>
          <button
            className="footer-info-button"
            onClick={() => feedbackMgr?.SetShowContactUs()}
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default Footer;
